export const getUrlParameter = name => {
  name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]")
  var regex = new RegExp("[\\?&]" + name + "=([^&#]*)")
  var results =
    typeof window !== "undefined" ? regex.exec(window.location.search) : null
  return results === null
    ? ""
    : decodeURIComponent(results[1].replace(/\+/g, " "))
}

export const getToken = () => {
  if (typeof window !== "undefined") {
    return getUrlParameter("id")
  } else {
    return ""
  }
}

/*
 * NT2-10971 - VEGAN GTM AB Test
 * if #vwoQuizAlt hidden input is true, it is variant experience
 * when VWO test is ended, search code and remove following
 * "vwoQuizAlt", "removeVwoQuestions", "dataWomenAlt", "isVwoAlt"
 */

/*
 * export const isVwoAlt = () => {
 *   if (typeof window !== `undefined`) {
 *     return sessionStorage.getItem("isQuizVariant") === "true"
 *   }
 *   return true
 * }
 */

export const showVeganQuestions = () => {
  return (typeof window !== `undefined`) && (localStorage.getItem("userAge") !== "fortyFivePlus")
}


export const getRecommendation = ()=>{
  //return "Women"
  return (typeof window !== `undefined`) ? (localStorage.getItem("reco") || "Women") : "Women"
}

/*
 * export const removeVwoQuestions = (json) => {
 *   const quizJson = JSON.parse(json)
 *   let alteredQuizJson = quizJson
 *   const alteredJsonBasics = quizJson.sections[0].questions.filter(question => question.globalid !== "veganq")
 *   alteredQuizJson.sections[0].questions = alteredJsonBasics
 *   alteredQuizJson = JSON.stringify(alteredQuizJson)
 *   return alteredQuizJson
 * }
 */

/*
 * export const skipNameQuestion = () => {
 *   return !!((typeof window !== `undefined`) && window['vwo_skip_name'])
 * }
 */